import { render, staticRenderFns } from "./FarmersPage.vue?vue&type=template&id=889aa402&"
import script from "./FarmersPage.vue?vue&type=script&lang=js&"
export * from "./FarmersPage.vue?vue&type=script&lang=js&"
import style0 from "./FarmersPage.vue?vue&type=style&index=0&id=889aa402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports